<script lang="ts" setup>
    import { useDisplay, useTheme } from 'vuetify';
    import authService from '@/services/authService';
    import { useMenuStore } from '@/stores/menu';
    import { useUserStore } from '@/stores/user';
    import AppMenuAccountChangeLocaleAndTimeZone from './AppMenuAccountChangeLocaleAndTimeZone.vue';
    import AppMenuAccountChangePasswordDialog from './AppMenuAccountChangePasswordDialog.vue';

    const theme = useTheme();
    const display = useDisplay();
    const { t } = useI18n();

    const userStore = useUserStore();
    const menuStore = useMenuStore();

    const showChangePasswordDialog = (): void => {
        changePasswordDialogRef.value.open();
    };

    const clickLogout = (): void => {
        authService.logout();
    };

    const changePasswordDialogRef = ref<any>(null);

    onMounted((): void => {
        console.log('Component app-menuAccountTB mounted.');
    });
</script>
<template>
    <v-menu class="menu-account" v-model="menuStore.userMenu" :close-on-content-click="false" location="bottom end" origin="top end" :viewport-margin="0">
        <template v-slot:activator="{ props }">
            <v-btn
                class="link-menu"
                :data-tooltip="t('menu.account')"
                :height="display.xs.value ? 30 : 46"
                min-width="30"
                :width="display.xs.value ? 30 : 50"
                variant="text"
                v-bind="props"
            >
                <v-icon size="24" :icon="mdiAccountBoxOutline" />
            </v-btn>
        </template>

        <v-card v-if="userStore.login" width="300" :border="theme.name.value === 'dark'">
            <div class="d-flex align-center justify-space-between px-3 py-1">
                <div class="text-grey font14">
                    &lt;
                    <span class="font-weight-bold text-tbGreen">{{ userStore.login }}</span>
                    /&gt;
                </div>
                <v-btn icon class="link-menu" variant="plain" size="28" @click="clickLogout()">
                    <v-icon :data-tooltip="t('menu.logout')" size="24" :color="theme.name.value === 'dark' ? undefined : '#867878'" :icon="mdiPower" />
                </v-btn>
            </div>

            <v-divider />

            <div class="d-flex align-center px-3 py-2 cursor-pointer" @click="showChangePasswordDialog">
                <v-icon color="primary" :icon="mdiLockReset" />
                <span class="pl-2 text-grey-darken-2">{{ t('menu.changePassword') }}</span>
            </div>

            <AppMenuAccountChangePasswordDialog ref="changePasswordDialogRef" />

            <AppMenuAccountChangeLocaleAndTimeZone />
        </v-card>
    </v-menu>
</template>

<style scoped lang="scss">
    .cursor-pointer {
        cursor: pointer;
    }
</style>
